(function() {

  /*

    ===== 編集するのは基本ここだけ =====



    写真URLは rankPhotos の image に入れます。

    image が空欄の場合は、仮の写真枠が表示されます。



    無料会員ページ：

    data-aqs-mode="limited"
    data-aqs-ids は不要



    プレミアムパス版：

    data-aqs-mode="full"

  */



  const aqsData = [

    {

      name: "アマゾンフロッグピット",

      kana: "あまぞんふろっぐぴっと",

      group: "あ行",

      id: "amazon-frogbit",

      summary: "葉の色・模様・大きさ・密度、根の充実度、全体のボリュームを重視します。",

      rankPhotos: [

        {

          rank: "S",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/S.jpg?v=1779243790",

          caption: "葉が大きく、青々としていて模様が少なく、根も充実している状態。"

        },

        {

          rank: "A",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/A_f3ebdbba-ee1c-40c7-a766-b83d4cf2ab92.jpg?v=1779243920",

          caption: "とてもきれいだが、Sよりやや小ぶりな状態。"

        },

        {

          rank: "B",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/B_bdb0707b-2ef1-4466-9cee-e359cae69e13.jpg?v=1779243993",

          caption: "標準的な状態。"

        },

        {

          rank: "C",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/C.jpg?v=1779244078",

          caption: "小ぶり、模様多数、葉が2枚、密度不足、根がわずかなど、見栄えが落ちる状態。"

        },

        {

          rank: "ランク外",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/6debbdd35acea140be5f6a745c60c940.png?v=1779244234",

          caption: "枯れ、色あせ、葉が1枚などの状態。"

        }

      ],

      points: [

        { axis: "葉", text: "色・模様・大きさ・密度" },

        { axis: "根", text: "量・長さ" },

        { axis: "体積", text: "全体のボリューム" },

        { axis: "茎", text: "対象外" }

      ],

      criteria: [

        { axis: "葉", item: "模様", s: "無", a: "少", b: "多", c: "多", ng: "枯れ・溶け" },

        { axis: "葉", item: "大きさ", s: "5cm〜", a: "4cm〜", b: "3cm〜", c: "〜3cm", ng: "-" },

        { axis: "葉", item: "密度", s: "葉4枚以上", a: "葉3枚以上", b: "葉3枚", c: "葉2枚", ng: "葉1枚" },

        { axis: "根", item: "量・長さ", s: "充実", a: "育つ", b: "育つ", c: "わずか", ng: "なし" },

        { axis: "体積", item: "重量", s: "1.5g〜", a: "0.8g〜", b: "0.4g〜", c: "〜0.4g", ng: "-" }

      ],

      comment: "アマゾンフロッグピットは、葉の大きさ・模様・色・根の状態・全体のボリュームで見栄えが大きく変わります。Aランク以上の個体は非常に美しいです。"

    },

    {

      name: "アナカリス",

      kana: "あなかりす",

      group: "あ行",

      id: "anacharis",

      summary: "葉の色・大きさ・密度、茎の長さ、全体のボリュームを重視します。",

      rankPhotos: [

        {

          rank: "S",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_5553.jpg?v=1779692835",

          caption: "葉が青々と密生していて、十分な長さがあり立派な状態。"

        },

        {

          rank: "A",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_7878.jpg?v=1779691861",

          caption: "とてもきれいだが、Sよりやや小ぶりな状態。"

        },

        {

          rank: "B",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_7884.jpg?v=1779692974",

          caption: "標準的な状態。"

        },

        {

          rank: "C",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_6122.jpg?v=1779693066",

          caption: "穂先が小ぶり、やや徒長が見られる、短い、貧弱な印象など、見栄えが落ちる状態。"

        },

        {

          rank: "ランク外",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/6debbdd35acea140be5f6a745c60c940.png?v=1779244234",

          caption: "穂先なし、極端に短い、枯れ、色あせなどの状態。"

        }

      ],

      points: [

        { axis: "葉", text: "色・大きさ・密度" },

        { axis: "茎", text: "長さ" },

        { axis: "体積", text: "全体のボリューム" },

        { axis: "根", text: "対象外" }

      ],

      criteria: [

        { axis: "葉", item: "色", s: "青々", a: "青々", b: "緑", c: "やや黒ずみ", ng: "枯れ・色あせ" },

        { axis: "葉", item: "大きさ", s: "-", a: "-", b: "-", c: "-", ng: "穂先なし" },

        { axis: "葉", item: "密度", s: "-", a: "-", b: "-", c: "やや徒長あり", ng: "-" },

        { axis: "茎", item: "長さ", s: "15㎝～", a: "10㎝～", b: "7㎝～", c: "5㎝～", ng: "～5㎝" },

        { axis: "体積", item: "重量", s: "3.5g〜", a: "2.5g〜", b: "1.5g〜", c: "1g～", ng: "～1g" }

      ],

      comment: "アナカリスは、穂先の有無、葉の色・密度、長さ・全体のボリュームで見栄えが大きく変わります。Ａランク以上はもさもさの印象ですが、細めが好みの方もいます。"

    },

    {

      name: "ウォーターマッシュルーム",

      kana: "うぉーたーまっしゅるーむ",

      group: "あ行",

      id: "water-mushroom",

      summary: "葉の大きさ、茎の長さ・自立性・まっすぐさ、根の状態を重視します。",

      rankPhotos: [

        {

          rank: "S",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/S_b3ff8f27-5b78-4a71-be8b-60baff56a61f.jpg?v=1779245371",

          caption: "葉がとても大きく丸く、茎がまっすぐに自立し、バランスが良い状態。"

        },

        {

          rank: "A",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/A2.jpg?v=1779245335",

          caption: "葉が立派できれいだが、Sよりやや小ぶりな状態。"

        },

        {

          rank: "B",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_6969.jpg?v=1779246178",

          caption: "標準的な状態。"

        },

        {

          rank: "C",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/C_85320980-6308-4226-9064-b7c7f0bc4115.jpg?v=1779246295",

          caption: "葉が小ぶり、茎が曲がる、長すぎる・短すぎるなど、見栄えが落ちる状態。"

        },

        {

          rank: "ランク外",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/6debbdd35acea140be5f6a745c60c940.png?v=1779244234",

          caption: "枯れ、葉が極端に小ぶり・変形、茎が極端に弱い・曲がっている状態。"

        }

      ],

      points: [

        { axis: "葉", text: "色・模様・大きさ" },

        { axis: "茎", text: "長さ・太さ・まっすぐさ" },

        { axis: "根", text: "量・長さ" },

        { axis: "体積", text: "対象外" }

      ],

      criteria: [

        { axis: "葉", item: "色", s: "立派", a: "立派", b: "良好", c: "やや模様あり", ng: "枯れ・変形" },

        { axis: "葉", item: "大きさ", s: "5cm〜", a: "4cm〜", b: "3cm〜", c: "2cm〜", ng: "〜2cm" },

        { axis: "茎", item: "長さ", s: "10〜20cm", a: "10〜20cm", b: "7〜10cm", c: "5〜7cm / 20cm〜", ng: "5cm未満" },

        { axis: "茎", item: "自立性", s: "自立", a: "自立", b: "自立", c: "重さに負ける", ng: "自立不可" },

        { axis: "茎", item: "まっすぐさ", s: "直立", a: "直立", b: "やや曲がる", c: "曲がる", ng: "大きく曲がる・折れ" },

        { axis: "根", item: "量・長さ", s: "充実", a: "充実", b: "数本", c: "わずか", ng: "なし" }

      ],

      comment: "ウォーターマッシュルームは、葉の大きさと形、茎の長さのバランスが見栄えに直結します。まっすぐに自立しているか、長さが極端でないかも重要です。"

    },

    {

      name: "カボンバ",

      kana: "かぼんば",

      group: "か行",

      id: "cabomba",

      summary: "葉の色・大きさ・密度、茎の長さ、全体のボリュームを重視します。",

      rankPhotos: [

        {

          rank: "S",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/2.jpg?v=1782116352",

          caption: "葉が青々と密生していて、十分な長さがあり立派な状態。"

        },

        {

          rank: "A",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/3.jpg?v=1782116391",

          caption: "とてもきれいだが、Sよりやや小ぶりな状態。"

        },

        {

          rank: "B",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/4.jpg?v=1782116438",

          caption: "標準的な状態。"

        },

        {

          rank: "C",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/6.jpg?v=1782116911",

          caption: "穂先が小ぶり、やや徒長が見られる、短い、貧弱な印象など、見栄えが落ちる状態。"

        },

        {

          rank: "ランク外",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/6debbdd35acea140be5f6a745c60c940.png?v=1779244234",

          caption: "穂先なし、極端に短い、枯れ、色あせなどの状態。"

        }

      ],

      points: [

        { axis: "葉", text: "色・大きさ・密度" },

        { axis: "茎", text: "長さ" },

        { axis: "体積", text: "全体のボリューム" },

        { axis: "根", text: "対象外" }

      ],

      criteria: [

        { axis: "葉", item: "色", s: "青々", a: "青々", b: "緑", c: "やや色あせ", ng: "枯れ・色あせ" },

        { axis: "葉", item: "大きさ", s: "-", a: "-", b: "-", c: "-", ng: "穂先なし" },

        { axis: "葉", item: "密度", s: "-", a: "-", b: "-", c: "やや徒長あり", ng: "-" },

        { axis: "茎", item: "長さ", s: "15㎝～", a: "10㎝～", b: "7㎝～", c: "5㎝～", ng: "～5㎝" },

        { axis: "体積", item: "重量", s: "3g〜", a: "2g〜", b: "1.5g〜", c: "1g～", ng: "～1g" }

      ],

      comment: "カボンバは、穂先の有無、葉の色・密度、長さ・全体のボリュームで見栄えが大きく変わります。葉が密生し、ボリュームのある株が美しく見えます。"

    },

    {

      name: "サルビニアククラータ",

      kana: "さるびにあくくらーた",

      group: "さ行",

      id: "salvinia-cucullata",

      summary: "葉の色と、1株当たりの密生具合を重視します。",

      rankPhotos: [

        {

          rank: "S",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_5418.jpg?v=1779249259",

          caption: "葉色が良く、密度が高く、1株が十分に大きい状態。"

        },

        {

          rank: "A",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_6968.jpg?v=1779246962",

          caption: "きれいだが、Sより1株がやや小さい状態。"

        },

        {

          rank: "B",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_6357.jpg?v=1779249293",

          caption: "標準的な状態。"

        },

        {

          rank: "C",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_7787.jpg?v=1779248488",

          caption: "葉の黒ずみ・色あせ、1株の小ささが目立つ状態。"

        },

        {

          rank: "ランク外",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/6debbdd35acea140be5f6a745c60c940.png?v=1779244234",

          caption: "枯れ、強い黒ずみ・色あせ、1株が極端に小さい状態。"

        }

      ],

      points: [

        { axis: "葉", text: "色・立ち上がり" },

        { axis: "茎", text: "対象外" },

        { axis: "根", text: "対象外" },

        { axis: "体積", text: "全体のボリューム" }

      ],

      criteria: [

        { axis: "葉", item: "色", s: "緑", a: "緑", b: "少々の黒ずみ・色あせ", c: "目立つ黒ずみ・色あせ", ng: "枯れ" },

        { axis: "葉", item: "立ち上がり", s: "良好", a: "良好", b: "少し弱い", c: "弱い", ng: "-" },

        { axis: "体積", item: "全体のボリューム", s: "〜5株で8cm", a: "6〜10株で8cm", b: "11〜15株で8cm", c: "16〜20株で8cm", ng: "極端に少ない" }

      ],

      comment: "サルビニアククラータは、葉の色と立ち上がり具合、1株当たりの大きさで印象が大きく変わります。黒ずみや色あせが目立つものや、1株の大きさが小さい個体は見栄えが落ちやすくなります。"

    },

    {

      name: "ヤマサキカズラ",

      kana: "やまさきかずら",

      group: "や行",

      id: "yamasakikazura",

      summary: "葉の色・大きさ・枚数、根の充実度を重視します。",

      rankPhotos: [

        {

          rank: "S",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_7790.jpg?v=1779259647",

          caption: "葉が大きく、葉先まできれいで、葉数が多く、根も充実している状態。"

        },

        {

          rank: "A",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_5869.jpg?v=1779258547",

          caption: "大きくてきれいだが、Sより葉先や葉数で少々見劣りする状態。"

        },

        {

          rank: "B",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_6286.jpg?v=1779258898",

          caption: "標準的な状態。"

        },

        {

          rank: "C",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/IMG_7789.jpg?v=1779259647",

          caption: "小ぶり、葉に大きな傷、根がないなど、見栄えが落ちる状態。"

        },

        {

          rank: "ランク外",

          image: "https\://cdn.shopify.com/s/files/1/0953/9007/3113/files/6debbdd35acea140be5f6a745c60c940.png?v=1779244234",

          caption: "枯れ、葉に修復不能な折れなどがある状態。"

        }

      ],

      points: [

        { axis: "葉", text: "色・大きさ・状態・葉数" },

        { axis: "根", text: "量・長さ" },

        { axis: "体積", text: "対象外" },

        { axis: "茎", text: "対象外" }

      ],

      criteria: [

        { axis: "葉", item: "色", s: "良好", a: "良好", b: "良好", c: "やや色あせあり", ng: "枯れ" },

        { axis: "葉", item: "大きさ", s: "20cm〜", a: "15cm〜", b: "10cm〜", c: "〜10cm", ng: "-" },

        { axis: "葉", item: "状態", s: "完品", a: "葉先の傷み", b: "少々の傷", c: "大きな傷", ng: "折れ" },

        { axis: "葉", item: "葉数", s: "3枚～", a: "2枚～", b: "1枚", c: "-", ng: "-" },

        { axis: "根", item: "量・長さ", s: "発根", a: "発根", b: "発根", c: "なし", ng: "-" }

      ],

      comment: "ヤマサキカズラは、葉の色・大きさ・状態・葉数・根の状態で見栄えが大きく変わります。葉先は特に傷みやすい性質があります。"

    },

  ];



  const groupOrder = ["あ行", "か行", "さ行", "た行", "な行", "は行", "ま行", "や行", "ら行", "わ行"];



  const groupIdMap = {

    "あ行": "a",

    "か行": "ka",

    "さ行": "sa",

    "た行": "ta",

    "な行": "na",

    "は行": "ha",

    "ま行": "ma",

    "や行": "ya",

    "ら行": "ra",

    "わ行": "wa"

  };



  function normalizeText(text) {

    return String(text || "")

      .toLowerCase()

      .replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {

        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);

      })

      .replace(/\s+/g, "");

  }



  function escapeHtml(str) {

    return String(str || "").replace(/[&<>"']/g, function(match) {

      return {

        "&": "&amp;",

        "<": "&lt;",

        ">": "&gt;",

        '"': "&quot;",

        "'": "&#039;"

      }[match];

    });

  }



  function getDisplayData() {
    const root = document.getElementById("aqs-top");

    if (!root) {
      return aqsData;
    }

    const mode = root.getAttribute("data-aqs-mode") || "full";
    const idsText = root.getAttribute("data-aqs-ids") || "";

    // 育成ガイドなどで個別IDが指定されている場合は、その品種だけ表示。
    if (idsText.trim() !== "") {
      const allowedIds = idsText
        .split(",")
        .map(function(id) {
          return id.trim();
        })
        .filter(Boolean);

      return aqsData.filter(function(item) {
        return allowedIds.indexOf(item.id) !== -1;
      });
    }

    // プレミアム版：AQS登録済み全種
    if (mode !== "limited") {
      return aqsData;
    }

    // 無料会員AQS：AMI無料版の水草8種のうち、AQS登録済みだけ
    const freeAqsNames = [
      "アナカリス",
      "マツモ",
      "カボンバ",
      "アマゾンフロッグピット",
      "ホテイアオイ",
      "ウィローモス",
      "ニューラージパールグラス",
      "アマゾンソード"
    ];

    return aqsData.filter(function(item) {
      return freeAqsNames.indexOf(item.name) !== -1;
    });
  }


  function renderCards(data) {

    const cardsRoot = document.getElementById("aqs-cards");

    const indexRoot = document.getElementById("aqs-index");



    if (!cardsRoot || !indexRoot) return;



    const sorted = data.slice().sort(function(a, b) {

      return a.kana.localeCompare(b.kana, "ja");

    });



    const activeGroups = groupOrder.filter(function(group) {

      return sorted.some(function(item) {

        return item.group === group;

      });

    });



    indexRoot.innerHTML = activeGroups.map(function(group) {

      const groupId = groupIdMap[group] || group;

      return '<a href="#aqs-group-' + groupId + '">' + group.replace("行", "") + '</a>';

    }).join("");



    cardsRoot.innerHTML = activeGroups.map(function(group) {

      const groupId = groupIdMap[group] || group;



      const items = sorted.filter(function(item) {

        return item.group === group;

      });



      const cards = items.map(function(item) {

        const searchText = normalizeText(

          item.name + " " +

          item.kana + " " +

          item.summary + " " +

          item.comment + " " +

          item.points.map(function(point) {

            return point.axis + " " + point.text;

          }).join(" ") + " " +

          item.criteria.map(function(row) {

            return row.axis + " " + row.item + " " + row.s + " " + row.a + " " + row.b + " " + row.c + " " + row.ng;

          }).join(" ")

        );



        return ''

          + '<a class="aqs-card" data-aqs-search="' + escapeHtml(searchText) + '" href="#aqs-' + escapeHtml(item.id) + '">'

          + '<div class="aqs-card-name">' + escapeHtml(item.name) + '</div>'

          + '<span class="aqs-card-more">写真で品質基準を見る</span>'

          + '</a>';

      }).join("");



      return ''

        + '<section id="aqs-group-' + groupId + '" class="aqs-group">'

        + '<h4 class="aqs-group-title">' + group + '</h4>'

        + '<div class="aqs-card-grid">'

        + cards

        + '</div>'

        + '</section>';

    }).join("");

  }



  function renderRankPhotos(item) {

    return ''

      + '<div class="aqs-photo-grid">'

      + item.rankPhotos.map(function(photo) {

        const isNg = photo.rank === "ランク外";

        const imageHtml = photo.image

          ? '<img src="' + escapeHtml(photo.image) + '" alt="' + escapeHtml(item.name + ' ' + photo.rank) + '">'

          : '<div class="aqs-photo-placeholder">写真URLを入れる</div>';



        return ''

          + '<div class="aqs-photo-card">'

          + '<div class="aqs-photo-frame">'

          + imageHtml

          + '<span class="aqs-rank-label' + (isNg ? ' aqs-rank-label-ng' : '') + '">' + escapeHtml(photo.rank) + '</span>'

          + '</div>'

          + '<div class="aqs-photo-body">'

          + '<span class="aqs-photo-rank">' + escapeHtml(photo.rank) + '</span>'

          + '<p class="aqs-photo-caption">' + escapeHtml(photo.caption) + '</p>'

          + '</div>'

          + '</div>';

      }).join("")

      + '</div>';

  }



  function renderPoints(item) {

    return ''

      + '<div class="aqs-point-grid">'

      + item.points.map(function(point) {

        return ''

          + '<div class="aqs-point-card">'

          + '<span class="aqs-point-name">' + escapeHtml(point.axis) + '</span>'

          + '<span class="aqs-point-text">' + escapeHtml(point.text) + '</span>'

          + '</div>';

      }).join("")

      + '</div>';

  }



  function renderCriteriaTable(item) {

    const rows = item.criteria.map(function(row) {

      return ''

        + '<tr>'

        + '<td class="aqs-table-axis">' + escapeHtml(row.axis) + '</td>'

        + '<td>' + escapeHtml(row.item) + '</td>'

        + '<td>' + escapeHtml(row.s) + '</td>'

        + '<td>' + escapeHtml(row.a) + '</td>'

        + '<td>' + escapeHtml(row.b) + '</td>'

        + '<td>' + escapeHtml(row.c) + '</td>'

        + '<td class="aqs-table-ng">' + escapeHtml(row.ng) + '</td>'

        + '</tr>';

    }).join("");



    return ''

      + '<div class="aqs-table-wrap">'

      + '<table class="aqs-table">'

      + '<thead>'

      + '<tr>'

      + '<th>評価軸</th>'

      + '<th>項目</th>'

      + '<th>S</th>'

      + '<th>A</th>'

      + '<th>B</th>'

      + '<th>C</th>'

      + '<th>ランク外</th>'

      + '</tr>'

      + '</thead>'

      + '<tbody>'

      + rows

      + '</tbody>'

      + '</table>'

      + '</div>';

  }



  function renderDetails(data) {

    const detailsRoot = document.getElementById("aqs-details");



    if (!detailsRoot) return;



    const sorted = data.slice().sort(function(a, b) {

      return a.kana.localeCompare(b.kana, "ja");

    });



    detailsRoot.innerHTML = sorted.map(function(item) {

      const searchText = normalizeText(item.name + " " + item.kana + " " + item.summary + " " + item.comment);



      return ''

        + '<section id="aqs-' + escapeHtml(item.id) + '" class="aqs-chap" data-aqs-search="' + escapeHtml(searchText) + '">'

        + '<div class="aqs-chap-head">'

        + '<h3>' + escapeHtml(item.name) + 'のAQS評価基準</h3>'

        + '<p class="aqs-summary">' + escapeHtml(item.summary) + '</p>'

        + '</div>'



        + '<h4 class="aqs-section-title">写真で見る品質ランク</h4>'

        + renderRankPhotos(item)



        + '<h4 class="aqs-section-title">この水草で見るポイント</h4>'

        + renderPoints(item)



        + '<h4 class="aqs-section-title">詳しい評価基準</h4>'

        + renderCriteriaTable(item)



        + '<div class="aqs-comment">'

        + escapeHtml(item.comment)

        + '</div>'

        + '</section>';

    }).join("");

  }



  function filterAqs() {

    const input = document.getElementById("aqs-search-input");

    const cards = document.querySelectorAll(".aqs-card");

    const groups = document.querySelectorAll(".aqs-group");

    const sections = document.querySelectorAll(".aqs-chap");



    if (!input) return;



    const query = normalizeText(input.value);

    let hitCount = 0;



    cards.forEach(function(card) {

      const matched = !query || (card.dataset.aqsSearch || "").indexOf(query) !== -1;



      card.classList.toggle("aqs-hidden", !matched);

      card.classList.toggle("aqs-hit", !!query && matched);



      if (matched) hitCount++;

    });



    groups.forEach(function(group) {

      const visibleCards = group.querySelectorAll(".aqs-card:not(.aqs-hidden)");

      group.classList.toggle("aqs-hidden", !!query && visibleCards.length === 0);

    });



    sections.forEach(function(section) {

      const matched = !query || (section.dataset.aqsSearch || "").indexOf(query) !== -1;

      section.classList.toggle("aqs-hidden", !matched);

    });



    let noResult = document.getElementById("aqs-no-result");



    if (!noResult) {

      noResult = document.createElement("div");

      noResult.id = "aqs-no-result";

      noResult.className = "aqs-no-result aqs-hidden";

      noResult.textContent = "該当する水草が見つかりませんでした。別のキーワードで検索してください。";



      const cardsRoot = document.getElementById("aqs-cards");

      if (cardsRoot) {

        cardsRoot.appendChild(noResult);

      }

    }



    noResult.classList.toggle("aqs-hidden", !query || hitCount > 0);

  }



  function bindSearch() {

    const input = document.getElementById("aqs-search-input");



    if (!input || input.dataset.aqsBound) return;



    input.dataset.aqsBound = "true";



    input.addEventListener("input", function() {

      filterAqs();

    });

  }



  function initAqs() {

    const displayData = getDisplayData();



    renderCards(displayData);

    renderDetails(displayData);

    bindSearch();

    filterAqs();

  }



  if (document.readyState === "loading") {

    document.addEventListener("DOMContentLoaded", initAqs);

  } else {

    initAqs();

  }



  setTimeout(initAqs, 100);



  document.addEventListener("shopify:section:load", function() {

    initAqs();

  });

})();